import { For, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { FilterOption } from '@/types/filters.types';

import FiltersMenuItem from './FiltersMenuItem';

type Props = { filterCategory: FilterOption[]; label: string; color?: string };

export default function FilterCategory({ filterCategory, label, color }: Readonly<Props>) {
  return (
    <VStack gap="tightL" height="100%" width="100%" padding="standardM" backgroundColor="neutral.700">
      <Text textStyle="screenStd" width="100%" color="neutral.200" textTransform="uppercase">
        <FormattedMessage id={label} />
      </Text>
      <VStack gap="standardS" width="100%">
        <For each={filterCategory}>
          {(filterOption) => <FiltersMenuItem key={filterOption.key} filterOption={filterOption} color={color} />}
        </For>
      </VStack>
    </VStack>
  );
}
